import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/system";
import { ChevronRight } from "@pmag/icons";
import { Typography } from "@pmag/ui-components";
import { CountChip } from "@src/components/countChip/CountChip";
import type * as React from "react";
import { useIntl } from "react-intl";

import { Card, LeftContainer, RightContainer, RowContainer } from "./CategoryCard.styles";

interface CategoryCardProps {
    count: number;
    description: string;
    onClick: () => void;
}

export const CategoryCard: React.FunctionComponent<CategoryCardProps> = ({ onClick, description, count }) => {
    const theme = useTheme();
    const intl = useIntl();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const countDescription = intl.formatMessage(
        {
            id: "sparePartsFinder.countChip.options",
            defaultMessage: "{count, plural, =1 {option} other {options}}",
        },
        { count },
    );

    if (isSmallScreen) {
        return (
            <RowContainer onClick={onClick}>
                <Typography variant="heading-08">{description}</Typography>

                <RightContainer>
                    <Typography variant="label-01" color={theme.palette.core.grey._60}>{`${count} ${countDescription}`}</Typography>

                    <ChevronRight color={theme.palette.core.grey._40} />
                </RightContainer>
            </RowContainer>
        );
    }

    return (
        <Card onClick={onClick}>
            <LeftContainer>
                <Box mb={2}>
                    <Typography variant="heading-06">{description}</Typography>
                </Box>

                <CountChip count={count} description={countDescription} />
            </LeftContainer>

            <ChevronRight color={theme.palette.core.grey._60} />
        </Card>
    );
};
